import { RouteProp } from '@react-navigation/native';
import { ParamListBase } from '@react-navigation/routers';
import { Sender } from '@sendbird/chat/message';
import React from 'react';

import { SendbirdMessage, SendbirdUserMessage } from '../../../Types';

export interface RouteProps extends RouteProp<ParamListBase, string> {
  params?: {
    isThread?: boolean;
    parentMessageId?: number;
  };
}

export interface ChatContextProps {
  isEditing: boolean;
  setIsEditing: (editing: boolean) => void;
  setActiveMessage: (message: SendbirdUserMessage | null) => void;
  selectedMessage: SendbirdUserMessage | null;
  setSelectedMessage: (message: SendbirdUserMessage | null) => void;
  setSelectedReaction: (reaction: string | null) => void;
  setTextMessage: (textMessage: string) => void;
  repliedMessage: SendbirdMessage | undefined;
  answeredPrayer: SendbirdMessage | undefined;
  setIsAnsweringPrayer: (isAnswering: boolean) => void;
  deleteMessage: () => void;
  reportMessage: () => void;
  handleSelectingMessage: () => void;
  handleSelectingReaction: (
    message: SendbirdUserMessage | null,
    reaction: string
  ) => void;
  handleSelectingUser: (user: Sender) => void;
}

export const ChatContext = React.createContext<Partial<ChatContextProps>>({});
